export class Note {
    public id: number;
    public title: string;
    public body: string;
    public createdOn: Date;
    public lastModifiedOn: Date;
    public author: any;
    public authorName: string;
    public caseId: number;
    public memberId: number;
    public taskId: string;
    public type: string;
    public editing = false;
    public isNew = false;
    public deleted = false;
}
